import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/salaryapproval/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";
import SalaryDetailModal from "../../components/salaryapproval/Salary Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export
import Switch from "react-switch";

export default function Salaryapproval() {
  const title = "Salary Approval Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);
  const [bulkClientId, setBulkClientId] = useState("");
  const [bulkFromDate, setBulkFromDate] = useState("");
  const [bulkToDate, setBulkToDate] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);
  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");
  const [clients, setClients] = useState([]);
  const [clientSearch, setClientSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showSalaryDetailModal, setShowSalaryDetailModal] = useState(false);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Name</b>,
      selector: (row) => row.id_user?.name || "-",
      sortable: true,
    },
    {
      name: <b>Approval</b>,
      cell: (row) => {
        const currentStatus = row.status || "Pending";
        const userRole = localStorage.getItem("userRole");

        const getStatusStyle = (status) => {
          switch (status) {
            case "Approved":
              return { backgroundColor: "#28a745", color: "#fff" }; // Green
            case "Rejected":
              return { backgroundColor: "#dc3545", color: "#fff" }; // Red
            case "Pending":
            default:
              return { backgroundColor: "#ffc107", color: "#212529" }; // Yellow
          }
        };

        const handleChange = (e) => {
          handleApprovalStatusChange(row._id, e.target.value);
        };

        const isDisabled =
          currentStatus !== "Pending" && userRole !== "superadmin";

        return (
          <div style={{ position: "relative", width: "120px" }}>
            <select
              value={currentStatus}
              onChange={handleChange}
              disabled={isDisabled}
              style={{
                width: "100%",
                padding: "8px 12px",
                fontWeight: "bold",
                borderRadius: "6px",
                border: "1px solid #ccc",
                outline: "none",
                backgroundColor: getStatusStyle(currentStatus).backgroundColor,
                color: getStatusStyle(currentStatus).color,
                cursor: !isDisabled ? "pointer" : "not-allowed",
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                textAlign: "center",
                transition: "all 0.2s ease-in-out",
              }}
              onMouseOver={(e) => {
                if (!isDisabled)
                  e.target.style.boxShadow = "0 0 0 2px #007bff55";
              }}
              onMouseOut={(e) => {
                e.target.style.boxShadow = "none";
              }}
            >
              {currentStatus === "Pending" || userRole === "superadmin" ? (
                <>
                  <option value="Pending">🟡 Pending</option>
                  <option value="Approved">✅ Approve</option>
                  <option value="Rejected">❌ Rejected</option>
                </>
              ) : (
                <option value={currentStatus}>
                  {currentStatus === "Approved"
                    ? "✅ Approved"
                    : currentStatus === "Rejected"
                      ? "❌ Rejected"
                      : "🟡 Pending"}
                </option>
              )}
            </select>
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: <b>Phone Number</b>,
      selector: (row) => row.id_user?.phonenumber || "-",
      sortable: true,
    },
    {
      name: <b>Client</b>,
      selector: (row) => row.id_client?.name || "-",
      sortable: true,
    },

    {
      name: <b>Pay Amount</b>,
      selector: (row) =>
        row.pay !== undefined && row.pay !== null
          ? `${Number(row.pay).toFixed(3)} /-`
          : "0.00/-",
      sortable: true,
    },
    {
      name: <b>Date</b>,
      selector: (row) => formatDate(row.date) || "-",
      sortable: true,
    },

    {
      name: <b>Approved By</b>,
      selector: (row) => {
        if (row.approved_by_admin) return "Admin";
        if (row.approved_by_clientmanager) return "Client Manager";
        if (row.approved_by_superadmin) return "Superadmin";
        return "-";
      },
      sortable: true,
    },
    {
      name: <b>Approved Name</b>,
      selector: (row) => {
        return (
          row.approved_by_admin_id?.name ||
          row.approved_by_clientmanager_id?.name ||
          row.approved_by_superadmin_id?.name ||
          "-"
        );
      },
      sortable: true,
    },
    {
      name: <b>Created At</b>,
      selector: (row) => new Date(row.createdAt).toLocaleDateString("en-IN"),
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <button
          onClick={() => viewSalaryapproval(row)}
          className="btn btn-primary btn-sm"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
  ];

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          setClients([]);
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.status === 200 && Array.isArray(response.data.clients)) {
          setClients(response.data.clients);
        } else {
          console.error("No clients found in the response.");
          setClients([]);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]);
      }
    };

    fetchClients();
  }, []);

  const filteredClients = clients.filter((client) =>
    (client.name || "")
      .toLowerCase()
      .includes(clientSearch.trim().toLowerCase()),
  );
  const handleApprovalStatusChange = async (id, status) => {
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole");

    if (!token || !userRole) {
      console.error("Token or user role not found");
      return;
    }

    let endpoint = "";
    if (userRole === "superadmin") {
      endpoint = "superadmin";
    } else if (userRole === "admin") {
      endpoint = "admin";
    } else if (userRole === "clientmanager") {
      endpoint = "clientmanager";
    } else {
      console.error("Invalid user role");
      return;
    }

    try {
      let apiUrl = "";
      let payload = { status };

      if (status === "Rejected") {
        // Rejection API
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v4/salary-approvals/${endpoint}/salary-approvals/reject/${id}`;
      } else {
        // Approval API
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v4/salary-approvals/${endpoint}/salary-approvals/approve/${id}`;
      }

      const response = await axios.patch(apiUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        Swal.fire("Success", "Approval status updated!", "success");
        fetchData(); // Refresh data
      } else {
        Swal.fire("Error", "Failed to update status", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const handleBulkApprove = async () => {
    const userRole = localStorage.getItem("userRole");
    const token = localStorage.getItem("token");

    if (userRole !== "superadmin") {
      Swal.fire(
        "Access Denied",
        "Only superadmin can bulk approve salary approvals.",
        "error",
      );
      return;
    }

    // At least a client or a complete date range is required.
    if (!bulkClientId && !bulkFromDate && !bulkToDate) {
      Swal.fire(
        "Missing Filters",
        "Please select a client or provide a date range.",
        "warning",
      );
      return;
    }

    if (Boolean(bulkFromDate) !== Boolean(bulkToDate)) {
      Swal.fire(
        "Invalid Date Range",
        "Please select both From Date and To Date.",
        "warning",
      );
      return;
    }

    if (bulkFromDate && bulkToDate && bulkFromDate > bulkToDate) {
      Swal.fire(
        "Invalid Date Range",
        "From Date cannot be after To Date.",
        "warning",
      );
      return;
    }

    const filtersDescription = [
      bulkClientId
        ? `Client: ${
            apistate.find(
              (item) =>
                (item.id_client?._id || item.id_client) === bulkClientId,
            )?.id_client?.name || "Selected client"
          }`
        : null,
      bulkFromDate ? `From: ${bulkFromDate}` : null,
      bulkToDate ? `To: ${bulkToDate}` : null,
    ]
      .filter(Boolean)
      .join("\n");

    const confirmation = await Swal.fire({
      title: "Confirm Bulk Approval",
      text: `All matching Pending salary approvals will be approved.\n\n${filtersDescription}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      cancelButtonText: "Cancel",
    });

    if (!confirmation.isConfirmed) return;

    try {
      setBulkLoading(true);

      const params = {};

      if (bulkClientId) params.clientId = bulkClientId;
      if (bulkFromDate) params.fromDate = bulkFromDate;
      if (bulkToDate) params.toDate = bulkToDate;

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/api/v4/salary-approvals/superadmin/bulk-approve`,
        {},
        {
          params,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        const approvedCount =
          response.data.data?.approvedCount ?? response.data.approvedCount ?? 0;

        await Swal.fire(
          "Success",
          `${approvedCount} salary approval(s) approved successfully.`,
          "success",
        );

        setBulkClientId("");
        setBulkFromDate("");
        setBulkToDate("");

        await fetchData();
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Bulk approval failed.",
          "error",
        );
      }
    } catch (error) {
      console.error("Bulk approval error:", error);

      Swal.fire(
        "Error",
        error.response?.data?.message ||
          "Something went wrong during bulk approval.",
        "error",
      );
    } finally {
      setBulkLoading(false);
    }
  };

  //By Default data must be of previous month. If not Present then latest month data
  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole");

      if (!token || !userRole) {
        console.error("Token or user role not found");
        return;
      }

      // Determine endpoint based on user role
      let endpoint = "";
      if (userRole === "superadmin") {
        endpoint = "superadmin";
      } else if (userRole === "admin") {
        endpoint = "admin";
      } else if (userRole === "clientmanager") {
        endpoint = "clientmanager";
      } else {
        console.error("Invalid user role");
        return;
      }

      const tryFetch = async (month, year) => {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v4/salary-approvals/${endpoint}/salary-approvals`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            params: { month, year },
          },
        );
        return response;
      };

      // Try previous month first
      const today = new Date();
      const prevMonthDate = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1,
      );
      const prevMonth = prevMonthDate.getMonth() + 1;
      const prevYear = prevMonthDate.getFullYear();

      let response = await tryFetch(prevMonth, prevYear);

      if (
        response.data.success &&
        Array.isArray(response.data.approvals) &&
        response.data.approvals.length > 0
      ) {
        setApiState(response.data.approvals);
        setApiCol(columns);
        return;
      }

      // Loop to find latest available data up to 12 months back
      for (let i = 0; i < 12; i++) {
        const loopDate = new Date(today.getFullYear(), today.getMonth() - i, 1);
        const loopMonth = loopDate.getMonth() + 1;
        const loopYear = loopDate.getFullYear();

        // Skip already tried month
        if (loopMonth === prevMonth && loopYear === prevYear) continue;

        const loopResponse = await tryFetch(loopMonth, loopYear);
        if (
          loopResponse.data.success &&
          Array.isArray(loopResponse.data.approvals) &&
          loopResponse.data.approvals.length > 0
        ) {
          setApiState(loopResponse.data.approvals);
          setApiCol(columns);

          Swal.fire({
            icon: "info",
            title: "Showing Latest Available Data",
            text: `No data found for ${prevMonth}/${prevYear}. Showing data for ${loopMonth}/${loopYear}`,
          });

          return;
        }
      }

      // No data found in the last 12 months
      setApiState([]);
      Swal.fire({
        icon: "info",
        title: "No Data Found",
        text: "No salary approval data available for the last 12 months.",
      });
    } catch (error) {
      console.error("Error fetching salary approval:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while fetching salary approvals.",
      });
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const viewSalaryapproval = (salaryapproval) => {
    setSelectedSalary(salaryapproval);
    setShowSalaryDetailModal(true);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((entry) => ({
      Name: entry.id_user?.name || "-",
      "Phone Number": entry.id_user?.phonenumber || "-",
      Email: entry.id_user?.email || "-",
      Client: entry.id_client?.name || "-",
      Hub: entry.id_hub?.name || "-",
      "Pay Amount": entry.pay?.toFixed(2) || "0.00",
      Date: formatDate(entry.date),
      "Approved By": entry.approved_by_admin
        ? "Admin"
        : entry.approved_by_clientmanager
          ? "Client Manager"
          : entry.approved_by_superadmin
            ? "Superadmin"
            : "-",
      "Approved Name":
        entry.approved_by_admin_id?.name ||
        entry.approved_by_clientmanager_id?.name ||
        entry.approved_by_superadmin_id?.name ||
        "-",
      Status: entry.status || "-",
      "Created At": formatDate(entry.createdAt),
      "Updated At": formatDate(entry.updatedAt),
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Approvals");

    XLSX.writeFile(workbook, "salary_approvals.xlsx");
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <SalaryDetailModal
        show={showSalaryDetailModal}
        onHide={() => setShowSalaryDetailModal(false)}
        salaryapproval={selectedSalary}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {/* {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="name"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )} */}

                {localStorage.getItem("userRole") === "superadmin" && (
                  <div
                    className="bulk-salary-card mb-4"
                    style={{
                      border: "1px solid #e2e8f0",
                      borderRadius: "7px",
                      background: "#fff",
                      overflow: "visible",
                    }}
                  >
                    {/* Header */}
                    <div
                      className="d-flex justify-content-between align-items-center flex-wrap"
                      style={{
                        padding: "17px 21px",
                        background: "#f8faff",
                        borderBottom: "1px solid #edf0f6",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          borderLeft: "4px solid #3730ff",
                          paddingLeft: "14px",
                        }}
                      >
                        <h5
                          className="mb-1"
                          style={{
                            fontSize: "18px",
                            fontWeight: 700,
                            color: "#101b45",
                          }}
                        >
                          Bulk Salary Approval
                        </h5>

                        <p
                          className="mb-0"
                          style={{ fontSize: "13px", color: "#7785a5" }}
                        >
                          Approve pending salary records using client and date
                          filters.
                        </p>
                      </div>

                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: "#50648f",
                          background: "#e8eef9",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Superadmin Only
                      </span>
                    </div>

                    {/* Filter Section */}
                    <div style={{ padding: "14px 20px 19px" }}>
                      <div className="row align-items-start">
                        {/* Client Selector */}
                        <div className="col-lg-4 col-md-6 mb-3">
                          <label
                            className="d-block mb-1"
                            style={{
                              fontSize: "12px",
                              fontWeight: 700,
                              color: "#263453",
                            }}
                          >
                            Client
                          </label>

                          <div style={{ position: "relative" }}>
                            <div style={{ position: "relative" }}>
                              <span
                                style={{
                                  position: "absolute",
                                  left: "13px",
                                  top: "9px",
                                  color: "#71809f",
                                  zIndex: 1,
                                }}
                              >
                                <i className="fa fa-search" />
                              </span>

                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search client by name..."
                                value={clientSearch}
                                onFocus={() => setShowClientDropdown(true)}
                                onChange={(e) => {
                                  setClientSearch(e.target.value);
                                  setShowClientDropdown(true);
                                }}
                                onBlur={() => {
                                  setTimeout(
                                    () => setShowClientDropdown(false),
                                    150,
                                  );
                                }}
                                style={{
                                  height: "36px",
                                  paddingLeft: "36px",
                                  paddingRight: "32px",
                                  border: "1px solid #d8e0ee",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  color: "#354464",
                                  boxShadow: "none",
                                }}
                              />

                              <span
                                style={{
                                  position: "absolute",
                                  right: "12px",
                                  top: "9px",
                                  color: "#71809f",
                                  pointerEvents: "none",
                                  fontSize: "12px",
                                }}
                              >
                                ▾
                              </span>
                            </div>

                            {showClientDropdown && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "40px",
                                  left: 0,
                                  right: 0,
                                  zIndex: 20,
                                  background: "#fff",
                                  border: "1px solid #d8e0ee",
                                  borderRadius: "6px",
                                  boxShadow:
                                    "0 5px 15px rgba(20, 35, 70, 0.12)",
                                  maxHeight: "220px",
                                  overflowY: "auto",
                                }}
                              >
                                <button
                                  type="button"
                                  className="w-100 text-left"
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={() => {
                                    setBulkClientId("");
                                    setClientSearch("");
                                    setShowClientDropdown(false);
                                  }}
                                  style={{
                                    display: "block",
                                    padding: "9px 12px",
                                    border: "none",
                                    borderBottom: "1px solid #edf0f6",
                                    background: !bulkClientId
                                      ? "#f0f5ff"
                                      : "#fff",
                                    color: "#354464",
                                    fontSize: "13px",
                                    textAlign: "left",
                                  }}
                                >
                                  All Clients
                                </button>

                                {filteredClients.map((client) => (
                                  <button
                                    key={client._id}
                                    type="button"
                                    className="w-100"
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => {
                                      setBulkClientId(client._id);
                                      setClientSearch(client.name || "");
                                      setShowClientDropdown(false);
                                    }}
                                    style={{
                                      display: "block",
                                      padding: "9px 12px",
                                      border: "none",
                                      borderBottom: "1px solid #f1f3f8",
                                      background:
                                        bulkClientId === client._id
                                          ? "#f0f5ff"
                                          : "#fff",
                                      color: "#354464",
                                      fontSize: "13px",
                                      textAlign: "left",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {client.name}
                                    {bulkClientId === client._id && (
                                      <span
                                        style={{
                                          float: "right",
                                          color: "#315efb",
                                        }}
                                      >
                                        ✓
                                      </span>
                                    )}
                                  </button>
                                ))}

                                {filteredClients.length === 0 && (
                                  <div
                                    style={{
                                      padding: "12px",
                                      fontSize: "13px",
                                      color: "#7785a5",
                                    }}
                                  >
                                    No clients found.
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Selected Client Chip */}
                          <div className="mt-1">
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "4px 11px",
                                borderRadius: "7px",
                                background: "#eaf2ff",
                                color: "#2361c9",
                                fontSize: "12px",
                                fontWeight: 600,
                              }}
                            >
                              {bulkClientId
                                ? clients.find(
                                    (client) => client._id === bulkClientId,
                                  )?.name || "Selected Client"
                                : "All Clients"}

                              <button
                                type="button"
                                aria-label="Clear client selection"
                                disabled={bulkLoading}
                                onClick={() => {
                                  setBulkClientId("");
                                  setClientSearch("");
                                }}
                                style={{
                                  border: "none",
                                  background: "transparent",
                                  color: "#2361c9",
                                  padding: 0,
                                  lineHeight: 1,
                                  cursor: "pointer",
                                  fontSize: "16px",
                                }}
                              >
                                ×
                              </button>
                            </span>
                          </div>
                        </div>

                        {/* From Date */}
                        <div className="col-lg-2 col-md-6 mb-3">
                          <label
                            className="d-block mb-1"
                            style={{
                              fontSize: "12px",
                              fontWeight: 700,
                              color: "#263453",
                            }}
                          >
                            From Date
                          </label>

                          <input
                            type="date"
                            className="form-control"
                            value={bulkFromDate}
                            max={bulkToDate || undefined}
                            onChange={(e) => setBulkFromDate(e.target.value)}
                            style={{
                              height: "36px",
                              border: "1px solid #d8e0ee",
                              borderRadius: "6px",
                              fontSize: "13px",
                              color: "#354464",
                              boxShadow: "none",
                            }}
                          />

                          <small
                            className="d-block mt-1"
                            style={{ color: "#7785a5", fontSize: "12px" }}
                          >
                            Start of approval period
                          </small>
                        </div>

                        {/* To Date */}
                        <div className="col-lg-3 col-md-6 mb-3">
                          <label
                            className="d-block mb-1"
                            style={{
                              fontSize: "12px",
                              fontWeight: 700,
                              color: "#263453",
                            }}
                          >
                            To Date
                          </label>

                          <input
                            type="date"
                            className="form-control"
                            value={bulkToDate}
                            min={bulkFromDate || undefined}
                            onChange={(e) => setBulkToDate(e.target.value)}
                            style={{
                              height: "36px",
                              border: "1px solid #d8e0ee",
                              borderRadius: "6px",
                              fontSize: "13px",
                              color: "#354464",
                              boxShadow: "none",
                            }}
                          />

                          <small
                            className="d-block mt-1"
                            style={{ color: "#7785a5", fontSize: "12px" }}
                          >
                            End of approval period
                          </small>
                        </div>

                        {/* Actions */}
                        <div className="col-lg-3 col-md-6 mb-3">
                          <label
                            className="d-block mb-1"
                            style={{ visibility: "hidden", fontSize: "12px" }}
                          >
                            Actions
                          </label>

                          <div className="d-flex" style={{ gap: "9px" }}>
                            <button
                              type="button"
                              className="btn"
                              disabled={bulkLoading}
                              onClick={() => {
                                setBulkClientId("");
                                setClientSearch("");
                                setBulkFromDate("");
                                setBulkToDate("");
                                setShowClientDropdown(false);
                              }}
                              style={{
                                flex: "0 0 36%",
                                height: "36px",
                                border: "1px solid #cbd5e1",
                                borderRadius: "6px",
                                background: "#f8fafc",
                                color: "#354464",
                                fontSize: "12px",
                                fontWeight: 600,
                              }}
                            >
                              Clear
                            </button>

                            <button
                              type="button"
                              className="btn"
                              onClick={handleBulkApprove}
                              disabled={bulkLoading}
                              style={{
                                flex: 1,
                                minWidth: 0,
                                height: "36px",
                                border: "none",
                                borderRadius: "6px",
                                background: bulkLoading ? "#fdad72" : "#ff8737",
                                color: "#fff",
                                fontSize: "12px",
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                                boxShadow: "none",
                              }}
                            >
                              {bulkLoading ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm mr-1"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  Processing...
                                </>
                              ) : (
                                "Approve Salaries"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Information Strip */}
                      <div
                        className="d-flex align-items-center"
                        style={{
                          gap: "11px",
                          padding: "10px 14px",
                          borderRadius: "7px",
                          background: "#f0f6ff",
                          color: "#53668e",
                          fontSize: "12px",
                          lineHeight: 1.6,
                        }}
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "0 0 18px",
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            background: "#3478e5",
                            color: "#fff",
                            fontSize: "12px",
                            fontWeight: 700,
                          }}
                        >
                          i
                        </span>

                        <span>
                          Only pending salary approvals matching the selected
                          filters will be approved. Select a client, a complete
                          date range, or both.
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="name"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>No salary approval data available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
